module.exports = __webpack_public_path__ + "img/hcp.9217bbfd.png";